import { RequireRole, useSession, AppShell } from "@saas/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, Link, Outlet, RouterProvider } from "react-router";
import { DashboardPage } from "./DashboardPage";
import { MyBookingsPage } from "./MyBookingsPage";
import { RoomsPage } from "./RoomsPage";

function Layout() {
  const session = useSession();
  return (
    <AppShell surfaceLabel="Workspace" nav={[
        { to: "/", label: "Dashboard" },
        { to: "/rooms", label: "Rooms" },
        { to: "/bookings", label: "My bookings" },
      ]} userLabel={session.email ?? "User"} logoutUrl={session.logoutUrl}>
      <Outlet />
    </AppShell>
  );
}

const router = createBrowserRouter(
  [
    {
      element: <Layout />,
      children: [
        { index: true, element: <DashboardPage /> },
        { path: "rooms", element: <RoomsPage /> },
        { path: "bookings", element: <MyBookingsPage /> },
        { path: "*", element: <p>Page not found. <Link to="/">Back to the dashboard</Link></p> },
      ],
    },
  ],
  { basename: "/app" },
);

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element.");

createRoot(root).render(
  <StrictMode>
    <RequireRole surface="user" title="Sign in to your workspace">
      <RouterProvider router={router} />
    </RequireRole>
  </StrictMode>,
);
